import React, { useEffect, useState } from "react";
import {
  CardContent,
  Box,
  Typography,
  CircularProgress,
} from "@material-ui/core";

import classes from "./index.module.scss";
import deleteFile from "client-sdk/src/common/file/deleteFile";
import registerFile from "client-sdk/src/common/file/registerFile";
import downloadFile from "client-sdk/src/common/file/downloadFile";
import RonadIcons from "./../../../components/iconComponent";
import handleNotfication from "../../../utils/handleNotfication";

type Props = {
  orderId: number;
  files: any;
  loading: boolean;
};

const DeliveryReceipt = (props: Props) => {
  const { orderId, files, loading } = props;
  const [isUploaded, setIsUploaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fileName, setFileName] = useState("");

  const MAX_FILE_SIZE = 1 * 1024 * 1024;

  const compressImage = async (file: File) => {
    return new Promise<File>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target?.result as string;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          const MAX_WIDTH = 800;
          const scaleSize = MAX_WIDTH / img.width;
          canvas.width = MAX_WIDTH;
          canvas.height = img.height * scaleSize;

          ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            (blob) => {
              if (blob) {
                resolve(new File([blob], file.name, { type: "image/jpeg" }));
              } else {
                reject(new Error("خطا در فشرده‌سازی تصویر"));
              }
            },
            "image/jpeg",
            0.7
          );
        };
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const handlerUploadFile = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setIsLoading(true);

    try {
      let uploadFile = file;

      if (file.size > MAX_FILE_SIZE) {
        uploadFile = await compressImage(file);
      }

      const res = await registerFile(
        orderId,
        "ORDER",
        "ORDER_DELIVERY_RECEIPT",
        uploadFile
      );

      if (res.ok) {
        handleNotfication("فایل رسید با موفقیت آپلود شد", "success");
        setIsUploaded(true);
        setFileName(uploadFile.name);
      }
    } catch (error) {
      handleNotfication("خطا در آپلود فایل", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handlerDeleteFile = async () => {
    setIsLoading(true);
    try {
      const res = await deleteFile(orderId, "ORDER", "ORDER_DELIVERY_RECEIPT");
      if (res.ok) {
        handleNotfication("فایل رسید با موفقیت حذف شد", "success");
        setIsUploaded(false);
        setIsLoading(false);
      }
    } catch (error) {}
  };

  const handlerDownloadFile = async () => {
    setIsLoading(true);
    try {
      const response = await downloadFile(
        orderId,
        "ORDER",
        "ORDER_DELIVERY_RECEIPT"
      );
      const blob = await response.blob;
      const fileUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = fileUrl;
      if (response.blob.type.includes("image")) {
        link.setAttribute("download", "order_receipt");
      } else if (response.blob.type.includes("pdf")) {
        link.setAttribute("download", "order_receipt.pdf");
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(fileUrl);
      setIsLoading(false);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  useEffect(() => {
    if (files?.length > 0) {
      const res = files.filter(
        (item: any) => item.fileType === "ORDER_DELIVERY_RECEIPT"
      );
      if (res.length > 0) {
        setIsUploaded(true);
        setFileName(res[0].name);
      }
    }
  }, [files]);

  return loading ? (
    <div className={classes.loading}>
      <CircularProgress />
    </div>
  ) : (
    <CardContent style={{ padding: "0px" }}>
      {isUploaded ? (
        <Box className={classes.isboxDownload}>
          <Typography
            style={{ textDecoration: "underline" }}
            onClick={handlerDownloadFile}
            variant="button">
            {fileName.slice(0, 22)}
          </Typography>
          <Typography
            onClick={handlerDeleteFile}
            className={classes.deleteFileStyle}
            color="error"
            variant="body1">
            حذف
          </Typography>
          {isLoading && (
            <div className={classes.isLoadingStyle}>
              <CircularProgress />
            </div>
          )}
        </Box>
      ) : (
        <Box className={classes.boxDownload}>
          <RonadIcons
            style={{ marginLeft: "10px" }}
            name="plus-circle"
            color="defualt"
            className="pointer"
            size="22"
          />
          <Typography variant="body1">افزودن رسید تحویل</Typography>
          <input
            disabled={isLoading}
            type="file"
            key={Date.now()}
            name="افزودن فایل رسید"
            className={classes.uploadInputStyle}
            onChange={handlerUploadFile}
          />
          {isLoading && (
            <div className={classes.isLoadingStyle}>
              <CircularProgress />
            </div>
          )}
        </Box>
      )}
    </CardContent>
  );
};

export default DeliveryReceipt;
